import { TeamTableRow } from './team-table-row';

export { TeamTableRow };
